export const breakpoints = {
  xs: "375px",
  small: "576px",
  medium: "768px",
  large: "992px",
  extraLarge: "1200px",
  extraExtraLarge: "1400px",
};
